<template>
  <div>
    <Dialog
      :visible.sync="rescheduleDialog1"
      :key="rescheduleDialogKey"
      :style="{ width: '700px', height: '597px', overflowY: 'auto' }"
      header="Schedule Details"
      :modal="true"
      class="p-fluid"
      id="scheduleDialog"
      @keyup="keyMonitor"
    >
      <div class="p-formgrid p-grid" style="height: 180px;">
        <div class="p-field p-col">
          <label for="startDate">Start Date*</label>
          <!-- <InputMask 
            mask="99/99/9999" 
            v-model="startDate" 
            slotChar="dd/mm/yyyy" 
            id="startDate"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.startDate }"
          /> -->
          <Calendar
            id="startDate"
            v-model="startDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.startDate }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.startDate"
            >Start Date is required.</small
          >
          <small class="p-invalid" v-if="showStartDateError"
            >Start Date and Time must be in the future.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="startTime">Start Time*</label>
          <!-- <InputMask 
            mask="99:99" 
            v-model="startTime" 
            slotChar="hh/mm" 
            id="startTime"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.startTime }"
          /> -->
          <Calendar
            id="startTime"
            v-model="startTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.startTime }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.startTime"
            >Start Time is required.</small
          >
          <small class="p-invalid" v-if="showStartDateError"
            >Start Date and Time must be in the future.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="endDate">Duration in minutes</label>
          <InputNumber
            id="duration"
            v-model.trim="thisActivity.duration"
            required="false"
            :class="{ 'p-invalid': submitted && !thisActivity.duration }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.duration"
            >Duration in minutes is required.</small
          >
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              @click="$emit('close')"
              style="width: 100px;"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <ProgressSpinner
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;"
              strokeWidth="5"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              @click="save"
              style="width: 100px;"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    scheduleDialog: {
      type: Boolean,
      required: true
    },
    reload: {
      type: Number,
      required: false
    },
    activity: {
      type: Object,
      required: true
    },
    sendingRequest: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    submitted: false,
    rescheduleDialogKey: 0,
    thisActivity: {},
    startDate: null,
    startTime: null,
    showStartDateError: false
  }),
  computed: {
    rescheduleDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.scheduleDialog;
      }
    }
  },
  watch: {
    startDate(val) {
      if (val) {
        this.analyzineStartTime();
        // let a = val.split('/')
        // if (a.length === 3) {
        //   let date = new Date(a[2], a[1], a[0]), year = date.getFullYear(), month = date.getMonth(), day = date.getDate(), hours = date.getHours(), minutes = date.getMinutes()
        //   this.thisActivity.startDate = new Date(year, month, day, hours, minutes)
        // }
        let year = val.getFullYear(),
          month = val.getMonth(),
          day = val.getDate(),
          hours = val.getHours(),
          minutes = val.getMinutes();
        this.thisActivity.startDate = new Date(
          year,
          month,
          day,
          hours,
          minutes
        );
      }
    },
    startTime(val) {
      if (val) {
        this.analyzineStartTime();
        let year = val.getFullYear(),
          month = val.getMonth(),
          day = val.getDate(),
          hours = val.getHours(),
          minutes = val.getMinutes();
        this.thisActivity.startTime = new Date(
          year,
          month,
          day,
          hours,
          minutes
        );
      }
    },
    activity(val) {
      this.thisActivity = { ...val };
    },
    reload() {
      this.refreshComponent();
    }
  },
  methods: {
    keyMonitor(event) {
      if (event.key === "Tab") {
        let a = document.activeElement;
        if (a) {
          let b = document.getElementsByClassName("p-datepicker p-component");
          b.forEach(c => {
            let found = false; // when moving from date to date (date === time)
            let found1 = true; // when going from date to dropdown (specially in primevue)

            c.parentElement.children.forEach(d => {
              //

              if (d.id === a.id) {
                found = true;
              }
              if (
                d.id &&
                a.parentElement.parentElement.id &&
                d.id !== a.parentElement.parentElement.id
              ) {
                found1 = false;
              }
            });
            //
            if (!found || !found1) {
              c.style.visibility = "hidden";
            }
          });
        }
      }
    },
    refreshComponent() {
      (this.thisActivity = {}),
        (this.startDate = null),
        (this.startTime = null),
        (this.showStartDateError = false),
        this.rescheduleDialogKey++;
    },
    analyzineStartTime() {
      if (this.startDate) {
        // let a = this.startDate.split('/')
        // if (a.length === 3) {
        // let startDate = new Date(a[2], a[1], a[0])
        let startDate = this.startDate;

        let year = startDate.getFullYear(),
          month = startDate.getMonth(),
          date = startDate.getDate(),
          hours = 0,
          minutes = 0;
        if (this.startTime) {
          (hours = this.startTime.getHours()),
            (minutes = this.startTime.getMinutes());
        }
        let day = new Date(year, month, date, hours, minutes);
        //
        if (day.getTime() > new Date().getTime()) {
          this.showStartDateError = false;
          this.thisActivity.startDate = this.startDate;
          this.thisActivity.startTime = this.startTime;
        } else {
          this.showStartDateError = true;
        }
        // }
      }
    },
    save() {
      this.submitted = true;
      //
      if (
        this.thisActivity.startDate &&
        this.thisActivity.startTime &&
        this.thisActivity.duration &&
        !this.showStartDateError
      ) {
        let ms = this.thisActivity.duration * 60000,
          year = this.thisActivity.startDate.getFullYear(),
          month = this.thisActivity.startDate.getMonth(),
          date = this.thisActivity.startDate.getDate(),
          hours = this.thisActivity.startTime.getHours(),
          minutes = this.thisActivity.startTime.getMinutes(),
          startFullTime = new Date(year, month, date, hours, minutes),
          startFullTimeInMS = startFullTime.getTime(),
          endFullTimeInMS = startFullTimeInMS + ms,
          endFullTime = new Date(endFullTimeInMS);

        if (endFullTime) {
          if ((month + 1).toString().length === 1) {
            month = "0" + (month + 1).toString();
          } else {
            month += 1;
          }
          if (date.toString().length === 1) {
            date = "0" + date.toString();
          }
          if (hours.toString().length === 1) {
            hours = "0" + hours.toString();
          }
          if (minutes.toString().length === 1) {
            minutes = "0" + minutes.toString();
          }

          this.thisActivity.startDate = `${date}/${month}/${year}`;
          this.thisActivity.startTime = `${hours}:${minutes}`;

          (year = endFullTime.getFullYear()),
            (month = endFullTime.getMonth()),
            (date = endFullTime.getDate()),
            (hours = endFullTime.getHours()),
            (minutes = endFullTime.getMinutes());

          if ((month + 1).toString().length === 1) {
            month = "0" + (month + 1).toString();
          } else {
            month += 1;
          }
          if (date.toString().length === 1) {
            date = "0" + date.toString();
          }
          if (hours.toString().length === 1) {
            hours = "0" + hours.toString();
          }
          if (minutes.toString().length === 1) {
            minutes = "0" + minutes.toString();
          }

          this.thisActivity.endDate = `${date}/${month}/${year}`;
          this.thisActivity.endTime = `${hours}:${minutes}`;

          this.$emit("save", this.thisActivity);
        }
      }
    }
  }
};
</script>

<style></style>
